/* ============================================
   Capacity.Li - Custom Homepage Interactions
   For Horizon Theme - Vanilla JS only, no jQuery
   ============================================ */

(function () {
  'use strict';

  /* ---------- Sticky Header Shadow ---------- */
  var siteHeader = document.querySelector('.capacity-site-header');
  if (siteHeader) {
    /* Check initial scroll position (e.g. browser back navigation) */
    if (window.scrollY > 0) {
      siteHeader.classList.add('is-sticky');
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > 0) {
            siteHeader.classList.add('is-sticky');
          } else {
            siteHeader.classList.remove('is-sticky');
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }
})();
